import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export type LinkedLeadDecision = "confirm" | "reject";

/**
 * The team's answer to an unverified link (docs/LEAD_MERGE.md): an Instagram lead
 * that typed the phone of an existing lead. «Confirmar» makes them one lead — the
 * Instagram one is absorbed into the target and disappears; «No es la misma
 * persona» unlinks them for good.
 *
 * Both are addressed on the TARGET, the person the team is looking at.
 */
export function useLinkedLeadDecision(targetId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ sourceId, decision }: { sourceId: string; decision: LinkedLeadDecision }) =>
      api.post<void>(`/crm/leads/${targetId}/linked/${sourceId}/${decision}`, {}),
    onSuccess: (_data, { sourceId, decision }) => {
      for (const id of [targetId, sourceId]) {
        void queryClient.invalidateQueries({ queryKey: ["lead", id] });
        void queryClient.invalidateQueries({ queryKey: ["messages", id] });
      }
      void queryClient.invalidateQueries({ queryKey: ["leads"] });
      void queryClient.invalidateQueries({ queryKey: ["inbox"] });
      toast.success(
        decision === "confirm"
          ? "Listo: ahora es un solo prospecto."
          : "Listo: quedan como prospectos distintos.",
      );
    },
    onError: (err: Error) => {
      toast.error(err.message);
    },
  });
}
